<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    title="退款说明设置"
    top="2vh"
    width="1400px"
  >
    <rich-text v-if="visible" v-model="remark"></rich-text>

    <template #footer>
      <div style="display: flex;justify-content: flex-end;">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import RichText from "@/components/richText.vue";
import poi from "@/api/poi";
const PoiModel = new poi();

export default {
  components: {
    RichText,
  },
  data(){
    return {
      remark: '',
      visible: false
    }
  },
  methods:{
    async open(){
      const res = await PoiModel.getRefundSetting({
        name:'dyLifePoiRefundTips'
      })
      if(!res.data.success){
        this.$message.error(res.data.message)
        return
      }

      this.remark = res.data.data
      this.visible = true
    },
    handleCancel(){
      this.visible = false
    },
    async handleConfirm(){
      const res = await PoiModel.setRefundRemark({
        name:'dyLifePoiRefundTips',
        value: this.remark,
      })

      if(!res.data.success){
        this.$message.error(res.data.message)
        return
      }
      this.$message.success('设置成功')
      this.handleCancel()
    }
  }
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponDyPoi/component/remarkPop.vue